<mat-selection-list  #horseSelect>
    <mat-list-option *ngFor="let horse of horses" [value]='horse'>
      <h3 matLine> {{horse.name}} </h3>
    </mat-list-option>
    <mat-list-option class="hide-checkbox" [value]="'new_horse'" >
        <mat-icon matListIcon>add</mat-icon>
        <h3 matLine> Add new horse </h3>
      </mat-list-option>
  </mat-selection-list>
